module.exports = __webpack_public_path__ + "static/vib_play2-035a59feb0a2634581842c4b92ac3d70.jpg";